module.exports = __webpack_public_path__ + "static/media/share-alt.5e9c8db7.svg";